import {
  AllInboxesStatusTime,
  EachInboxesStatusTimeI,
} from 'store/models/InboxesStatusTime';
import { websocketConstants } from '../constants';
import { WS_UPDATE_COUNT_EVENT } from '../constants/num-ticket.constants';
import {
  WS_ERROR,
  WS_GET_UPDATE_EVENT,
} from '../constants/workdesk-tickets.constants';
import AppWebSocket from '../models/AppWebSocket';
import { RelatedObjI } from '../models/Statuses';
import { alertsActions } from './alerts.actions';
import { numTicketsActions } from './num-tickets.action';
import { workdeskTicketsActions } from './workdesk-tickets.actions';

const allInboxesStatusLatestReceivedTimeSelector = (state) =>
  state.websocket.allInboxesStatusLatestReceivedTime;

const _wsConnect = (host, path) => ({
  type: websocketConstants.WS_CONNECT,
  payload: { host, path },
});

const wsConnect = () => {
  return (dispatch) => {
    console.debug(`call dispatch wsConnect in websocket actions`);
    dispatch(
      _wsConnect(process.env.REACT_APP_WS_HOST, '/api/socket.io'),
    );
  };
};

const wsConnected = (socketId) => ({
  type: websocketConstants.WS_CONNECTED,
  payload: { socketId },
});

/**
 * TODO: check if this is used anywhere
 * @param socketId
 */
const wsDisconnect = (socketId?) => ({
  type: websocketConstants.WS_DISCONNECT,
  payload: { socketId },
});
const wsDisconnected = (socketId) => ({
  type: websocketConstants.WS_DISCONNECTED,
  payload: { socketId },
});

const wsEmit = (msg, data) => {
  return {
    type: websocketConstants.WS_EMIT,
    payload: {
      msg,
      data,
    },
  };
};

const wsOnEvent = (msg, data) => {
  const onEvent = () => ({
    type: websocketConstants.WS_EVENT,
    payload: {
      msg,
      data,
    },
  });
  return (dispatch) => {
    dispatch(onEvent());
    if (msg === WS_GET_UPDATE_EVENT) {
      console.debug('websocket add data', data);
      dispatch(
        workdeskTicketsActions.wsLoadWorkdeskTicketsSuccess(data),
      );
    } else if (msg === WS_UPDATE_COUNT_EVENT) {
      dispatch(numTicketsActions.updateNumTicket(data));
    } else if (msg === WS_ERROR) {
      console.debug(`websocket error: `, data);
      if (data && typeof data === 'string') {
        dispatch(alertsActions.error(data));
      }
    }
  };
};

const _setUseWebSocket = (useWebSocket: boolean) => {
  return {
    type: websocketConstants.SET_USE_WEB_SOCKET,
    payload: {
      useWebSocket,
    },
  };
};

const reviveUseWebsocketFromLocalStorage = () => {
  return (dispatch) => {
    const useWebSocket = AppWebSocket.getUseWebSocket();
    dispatch(_setUseWebSocket(useWebSocket));
  };
};

const setUseWebsocketToLocalStorage = (val: boolean) => {
  return (dispatch) => {
    AppWebSocket.setUseWebSocket(val);
    dispatch(_setUseWebSocket(val));
  };
};

const clearUseWebsocketFromLocalStorage = () => {
  return (dispatch) => {
    AppWebSocket.clearUserWebSocket();
    dispatch(_setUseWebSocket(false));
  };
};

const updateStatusesInboxesLatestReceivedTime = (
  relatedObj: RelatedObjI,
  inboxes: string[],
  datetime: string | null,
) => {
  return (dispatch, getState) => {
    const allInboxesStatusLatestReceivedTime = allInboxesStatusLatestReceivedTimeSelector(
      getState(),
    );
    const data = new AllInboxesStatusTime(
      allInboxesStatusLatestReceivedTime,
    ).update(
      relatedObj,
      inboxes,
      datetime,
    ) as EachInboxesStatusTimeI[];
    dispatch({
      type:
        websocketConstants.UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME,
      payload: {
        data,
      },
    });
  };
};

const updateStatusesInboxesLatestReceivedTimeWithData = (
  relatedObj: RelatedObjI,
  inboxes: string[],
  datetime: string | null,
) => {
  return (dispatch, getState) => {
    const allInboxesStatusLatestReceivedTime = allInboxesStatusLatestReceivedTimeSelector(
      getState(),
    );
    const data = new AllInboxesStatusTime(
      allInboxesStatusLatestReceivedTime,
    ).update(
      relatedObj,
      inboxes,
      datetime,
    ) as EachInboxesStatusTimeI[];
    dispatch({
      type:
        websocketConstants.UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME_WITH_DATA,
      payload: {
        data,
      },
    });
  };
};

const wsConnectError = (message: string) => {
  return {
    type: websocketConstants.WS_CONNECT_ERROR,
    payload: {
      message,
    },
  };
};
export const webSocketActions = {
  wsConnect,
  wsConnected,
  wsDisconnect,
  wsDisconnected,
  wsEmit,
  wsOnEvent,
  reviveUseWebsocketFromLocalStorage,
  setUseWebsocketToLocalStorage,
  clearUseWebsocketFromLocalStorage,
  wsConnectError,

  updateStatusesInboxesLatestReceivedTime,
  updateStatusesInboxesLatestReceivedTimeWithData,
};
